<template>
  <div class="outer-div-min">
    <div class="inner-div">
        <div class='center'>
          <ul class='inline-block'>
            <button @click="goBack()" class="float-left">
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
              {{ 'Back' }}&nbsp;
            </button>
            <router-link
              tag='li'
              v-if="buttonEnabled"
              active-class='active-router'
              to="/chart-graph-simulation/simulation">
              <span onclick="">Response Simulation</span>
            </router-link>
            <router-link
              tag='li'
              active-class='active-router'
              to="/chart-graph-simulation/past-trends">
              <span onclick="" id="defaultOpen">Past Trends</span>
            </router-link>
            <router-link
              tag='li'
              active-class='active-router'
              to="/chart-graph-simulation/waterfall">
              <span onclick="">Waterfall</span>
            </router-link>
          </ul>
        </div>
        <router-view></router-view>
    </div>
  </div>
</template>
<script>
// import { mockChartData } from './mock'
export default {
  data () {
    return {
      previousRouterPath: '/pending-offers/offer-select',
      buttonEnabled: true
    }
  },
  methods: {
    goBack () {
      this.$router.push(this.previousRouterPath)
    }
  },
  created () {
    this.buttonEnabled = this.$route.params.buttonEnabled
  }
}
</script>
<style scoped>
  ul {
    list-style-type: none;
    text-align: center;
    font-size: 1.5rem;
    padding-left: 0;
    background-color: '#eeeeee';
    margin-top: 0;
    display: block;
  }

  li {
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: .5rem;
    padding-bottom: .5rem;
    display: inline-block;
  }
  li:hover {
    background: #eeeeee;
    cursor: pointer;
  }
  .active-router {
    background: #f3f3f3
  }
  button {
    background: #6c6f70;
  }
  button:hover {background-color: #05983b}
  .float-left {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// GraphSimulationNavBar.vue?cfc98da0